export default __webpack_public_path__ + "45a8fd9d9050fbc3e06a7dad143f0e10.png";